import type { FC } from 'react';

import OneXbetLogo from 'assets/icons/1xbet/1xbet-logo.png';
import BetCityLogo from 'assets/icons/bet-city/bet-city-logo.svg';
import FonbetLogo from 'assets/icons/fonbet/fonbet-logo.png';
import { FORM_KEY } from 'constants/form-ids';
import { twMergeClsx } from 'utils';

import type { LogoKassaStyle } from '../../components/base/ui';
import { DotLoader, LogoKassa } from '../../components/base/ui';

interface LoadingStateProps {
  title?: string;
  message?: string;
  formKey?: string;
  className?: string;
  dotClassName?: string;
  logoStyle?: LogoKassaStyle;
}

const LoadingState: FC<LoadingStateProps> = ({
  title = 'Немного терпения',
  message = 'Идет обработка запроса',
  formKey = 'default',
  className,
  dotClassName,
  logoStyle,
}) => {
  return (
    <div className="flex flex-col items-center gap-8">
      {(formKey === 'default' || formKey === FORM_KEY.KASE) && <LogoKassa style={logoStyle} />}
      {formKey === FORM_KEY.XBET && <img src={OneXbetLogo} alt="1xbet logo" className="w-36" />}
      {formKey === FORM_KEY.BET_CITY && (
        <img src={BetCityLogo} alt="bet city logo" className="w-36" />
      )}
      {formKey === FORM_KEY.FONBET && <img src={FonbetLogo} alt="fonbet logo" className="w-36" />}
      <DotLoader formKey={formKey} className={dotClassName} />

      <div
        className={twMergeClsx(
          'flex flex-col items-center gap-2 text-white',
          {
            'text-skin-base': formKey === FORM_KEY.SZ,
            'text-1xbet-gray-300': formKey === FORM_KEY.XBET,
            'text-fonbet-gray-200': formKey === FORM_KEY.FONBET,
          },
          className,
        )}
      >
        <h3>{title}</h3>
        <p className="text-sm">{message}</p>
      </div>
    </div>
  );
};

export { LoadingState };
